import react, {Component, useState} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Grid from '@mui/material/Grid'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { DateTime } from 'luxon';

import EventosTable from './EventosTable'
import DepositosTable from './DepositosTable'
import RetirosTable from './RetirosTable'
import SaldoCajerosTable from './SaldoCajerosTable'

import ItemEstadoCajero from './ItemEstadoCajero'
import { Paper, Chip, Stack } from '@mui/material'

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

var intervaloUpdateEstadoCajero = 10000

class CajerosResumenPage extends Component {

  constructor(props) {
    super(props)

    this.idCajero = props.location.state.id_cajero

    this.state = {
      cajero: [],
      categoriasEstados: [],
      estadosCajero: [],
      eventos: [],
      depositos: [],
      retiros: [],
      registros: [],
      mostrarAlerta: true,
      mensajeAlerta: '',
      severidadAlerta: '',
    }

    this.updateEstadoCajero = this.updateEstadoCajero.bind(this)

  }

  showAlert = (mensaje, severidad) => {
    this.setState({
        mostrarAlerta: true,
        mensajeAlerta: mensaje,
        severidadAlerta: severidad,
    });
  }

  handleCloseAlert= (event, reason) => {
    if (reason === 'clickaway') {
      return; // Evitar que se cierre si el usuario hace clic fuera
    }
    this.setState({ mostrarAlerta: false })
  }

  componentDidMount() {
	  this.queryCategoriasEstados()
    this.queryCajero()
    this.updateEstadoCajero()
    this.queryEventos()
    this.queryDepositos()
    this.queryRetiros()
    this.querySaldos()

    this.timerRefrescarEstadoCajero = setInterval(this.updateEstadoCajero, intervaloUpdateEstadoCajero)
  }

  componentWillUnmount() {
    console.log("Desmontado")
    clearInterval(this.timerRefrescarEstadoCajero)
  }

  queryCajero() {
	   console.log('Consultando cajero....')
        
        var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {
		  	id_cajero: this.idCajero
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/detalle' 
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
          this.showAlert('Error consultando cajero', 'error')
	        //alert("Error consultando cajero")
	        //console.log('Error respuesta consultando cajero')
	        this.setState({
            cajero: {},
            mensajeError: data.message
	        })
	      } else {
	        //console.log('Cajero consultado')
	      	this.setState({
                cajero: data
            })
	      }
	    })
   }
   
   queryCategoriasEstados() {
        //console.log('Consultando lista estados....')
        
        var restArgs = {
          method: 'POST',
          headers: 'JSON',
          body: {},
          url: process.env.REACT_APP_URL_BACKEND + '/cajeroestados/listaestados'
        }
    
        RestTunel.makePetition(restArgs,(err, data) => {
          if(err) {
            this.showAlert('Error consultando lista estados', 'error')
            //alert("Error consultando lista estados")
            //console.log('Error respuesta consultando lista estados')
	        this.setState({
            categoriasEstados: [],
            mensajeError: data.message
	        })
	      } else {
            //console.log('Estados consultados')
          	this.setState({
            	categoriasEstados: data.categoriasEstados
            })
          }
        })
    }

  updateEstadoCajero() {
    //console.log('Consultando estado')
        var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {
		  	id_cajero: this.idCajero
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/cajeroestados/estado' 
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
          this.showAlert('Error consultando estado', 'error')
	        //alert("Error consultando estado")
	        //console.log('Error respuesta consultando estado')
	        this.setState({
            estadosCajero: [],
            mensajeError: data.message
	        })
	      } else {
	        //console.log('Estado consultado')
	      	this.setState({
                estadosCajero: data.estados
            })
	      }
	    })
    
   }

 queryEventos() {
   console.log('Consultando eventos...')
   
   var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
	  	filtro_id_cajero: this.idCajero,
      filtro_fecha_inicio: "2020-01-01 00:00:00",
      filtro_fecha_fin: DateTime.now().toFormat("yyyy-MM-dd") + " 23:59:59"
	  },
      url: process.env.REACT_APP_URL_BACKEND + '/eventos/list' 
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        this.showAlert('Error consultando eventos', 'error')
        //alert("Error consultando eventos")
        //console.log('Error respuesta consultando eventos')
        this.setState({
          eventos: [],
          mensajeError: data.message
        })
      } else {
        //console.log('Eventos consultados')
      	const ultimos20 = data.data.slice(0, 10); //los primeros 20
        this.setState({ eventos: ultimos20 });
      }
    })
   
  }

  queryDepositos() {
    console.log('Consultando depositos....')
    console.log(" ID DEL CAJERO ", this.idCajero)


	  var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
	  	filtro_id_cajero: this.idCajero,
      filtro_fecha_inicio: "2020-01-01 00:00:00",
      filtro_fecha_fin: DateTime.now().toFormat("yyyy-MM-dd") + " 23:59:59"
	  },
      url: process.env.REACT_APP_URL_BACKEND + '/depositos/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        this.showAlert('Error consultando depositos', 'error')
        //alert("Error consultando depositos")
        //console.log('Error respuesta consultando depositos')
        this.setState({
          depositos: [],
          mensajeError: data.message
        })
      } else {
        const ultimos20Depositos = data.slice(0, 10); //los primeros 20
        this.setState({ depositos: ultimos20Depositos });
      	
        console.log("INFO DEPOSITO ", ultimos20Depositos)
      }
    })

  }

  queryRetiros() {
     //console.log('Consultando retiros....')

	  var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
	  	filtro_id_cajero: this.idCajero,
      filtro_fecha_inicio: "2020-01-01 00:00:00",
      filtro_fecha_fin: DateTime.now().toFormat("yyyy-MM-dd") + " 23:59:59"
	  },
      url: process.env.REACT_APP_URL_BACKEND + '/retiros/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        this.showAlert('Error consultando retiros', 'error')
        //alert("Error consultando retiros")
        //console.log('Error respuesta consultando retiros')
        this.setState({
          retiros: [],
          mensajeError: data.message
        })
      } else {
        //console.log('Retiros consultados')
      	const ultimos20 = data.slice(0, 10); //los primeros 20
        this.setState({ retiros: ultimos20 });
      	
        console.log("INFO RETIROS ", ultimos20)
      }
    })
  }

  queryDetalles(fechaRecaudo, callback) {
      console.log('Consultando Detalles para:', fechaRecaudo);
      var restArgs = {
        method: 'POST',
        headers: 'JSON',
        body: { fecha_recaudo: fechaRecaudo },
        url: process.env.REACT_APP_URL_BACKEND + '/retiros/detalles'
      };
    
      RestTunel.makePetition(restArgs, (err, data) => {
        if (err) {
          console.error('Error consultando detalles:', err);
          callback([]); // Pasar un array vacío en caso de error
        } else {
          console.log("Respuesta del backend:", data);
          this.setState({
            detallesPorFecha: data
          })
          callback(data); // Pasar los datos al callback
        }
      });
  }

  querySaldos() {
      
      var restArgs = {
        method: 'POST',
        headers: 'JSON',
        body: {
        filtro_id_cajero: this.idCajero,
        filtro_fecha_inicio: "2020-01-01 00:00:00",
        filtro_fecha_fin: DateTime.now().toFormat("yyyy-MM-dd") + " 23:59:59"
      },
        url: process.env.REACT_APP_URL_BACKEND + '/reportes/saldocajeros/'
      }
  
      RestTunel.makePetition(restArgs,(err, data) => {
        if(err) {
          // alert("Error consultando saldos")
          console.log('Error respuesta consultando saldos')
          this.setState({
            registros: [],
            mensajeError: data.message,
            mostrarAlerta: true,
            mensajeAlerta: 'Error consultando saldos',
            severidadAlerta: 'error'
          })
        } else {
          console.log('Saldos consultados')
          this.setState({
            registros: data
          })
        }
      })
  
  }
  
  calcularArqueoPorDetalle = (detalle) => {
    const arqueoMap = new Map();
  
    try {
      if (!detalle) {
        console.warn(`Sin detalle`);
        return [];
      }
  
      const arrayDetalle = `[${detalle}]`;
      const parsedDetalles = JSON.parse(arrayDetalle);
  
      parsedDetalles.forEach((contenido) => {
        const secciones = Object.values(contenido);
  
        secciones.forEach((seccion) => {
          if (seccion?.currencies?.length) {
            seccion.currencies.forEach((currency) => {
              if (currency?.bills?.length) {
                currency.bills.forEach((bill) => {
                  const denom = bill.denomination;
                  const cantidad = bill.amount;
  
                  arqueoMap.set(denom, (arqueoMap.get(denom) || 0) + cantidad);
                });
              }
            });
          }
        });
      });
    } catch (e) {
      console.error("Error parseando el detalle:", e, detalle.detalle);
    }
  
    const arqueoFinal = {};
      Array.from(arqueoMap.entries())
        .sort((a, b) => b[0] - a[0]) // Orden descendente por denominación
        .forEach(([denominacion, cantidad]) => {
          arqueoFinal[`Bill_${denominacion}`] = cantidad;
        });
  
        console.log(arqueoFinal)
      return arqueoFinal;
  };

  renderSeccion(titulo, contenido) {
    return (
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          mb: 3,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.5,
            bgcolor: (theme) => theme.palette.grey[50],
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {titulo}
          </Typography>
        </Box>
        <Box sx={{ p: 2, overflowX: 'auto' }}>
          {contenido}
        </Box>
      </Paper>
    )
  }

  render() {
    const cajero = this.state.cajero || {}
    const activo = cajero.estado === 'A'
    const entidadesList = (cajero && cajero.entidades)
      ? cajero.entidades.split('**-**').map(e => e.trim()).filter(Boolean)
      : []

    const datos = [
      ['Codigo', cajero.codigo],
      ['Serial', cajero.serial],
      ['Alias', cajero.alias],
      ['Fecha registro', cajero.fecha_registro],
      ['Direccion', cajero.direccion],
    ]

    return (
      <Container sx={{ py: 2 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Resumen del cajero
          </Typography>
          {(cajero.alias || cajero.codigo) &&
            <Typography variant="body2" color="text.secondary">
              {cajero.alias}{cajero.codigo ? ' · ' + cajero.codigo : ''}
            </Typography>
          }
        </Box>

        <Grid container spacing={2} alignItems="stretch" sx={{ mb: 1 }}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                  <Typography variant="h6">Datos del cajero</Typography>
                  <Chip
                    label={activo ? 'Activo' : 'Inactivo'}
                    color={activo ? 'success' : 'default'}
                    size="small"
                    variant={activo ? 'filled' : 'outlined'}
                  />
                </Stack>
                <Divider sx={{ mb: 2 }} />
                <Grid container rowSpacing={2} columnSpacing={2}>
                  {datos.map(([label, value]) => (
                    <Grid item xs={12} sm={6} key={label}>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                        {label}
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500, wordBreak: 'break-word' }}>
                        {value || '—'}
                      </Typography>
                    </Grid>
                  ))}
                  <Grid item xs={12}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                      Entidades
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {entidadesList.length
                        ? entidadesList.map((e, i) => (
                            <Chip key={i} label={e} size="small" variant="outlined" />
                          ))
                        : <Typography variant="body2">—</Typography>}
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {session.checkPermiso('ver_estado_cajero') &&
            <Grid item xs={12} md={6}>
              <ItemEstadoCajero
                categoriasEstados={this.state.categoriasEstados}
                estadosCajero={this.state.estadosCajero}
              />
            </Grid>
          }
        </Grid>

        {this.renderSeccion('Ultimos saldos', <SaldoCajerosTable registros={this.state.registros} />)}
        {this.renderSeccion('Ultimos depositos', <DepositosTable depositos={this.state.depositos} />)}
        {this.renderSeccion('Ultimos recaudos',
          <RetirosTable
            retiros={this.state.retiros}
            detallesPorFecha={this.state.detallesPorFecha}
            queryDetalles={this.queryDetalles.bind(this)}
          />
        )}
        {this.renderSeccion('Ultimos eventos', <EventosTable eventos={this.state.eventos} />)}
      </Container>
    )
  }
}

export default CajerosResumenPage
